import React from 'react';

const Schedules = () => {
  return (
    <div>Schedules</div>
  )
}

export default Schedules;